export const NAV_BAR_ICON_SIZE = 20;

export const NAV_X_PADDING = 14;
